
import React, { useState, useEffect } from 'react';
import { loadClientSummary } from "../../api/clienteApi";

const ClientSummary = ({ searchParams }) => {
  const [ticketSummary, setTicketSummary] = useState([]);
  const [loading, setLoading] = useState(false);
  const params = {
    page: 1,
    pageSize: 10,
    sortField: "",
    sortOrder: "",
    searchText: searchParams.searchText ?? "",
  };
  const fetchTicketSummary = async () => {
    console.log("Fetching ticket summary with params:", searchParams.searchText);
    if (!searchParams || !searchParams.searchText) {
      console.warn("No search text provided, skipping fetch.");
      return;
    } else {
      try {
        setLoading(true);
        const response = await loadClientSummary(params);
        if (response.status === 200) {
          setTicketSummary(response.data);
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    const handlePageLoad = () => {
      fetchTicketSummary();
    };
    if (document.readyState === "complete") {
      handlePageLoad();
    } else {
      window.addEventListener("load", handlePageLoad);
    }

    window.addEventListener("load", handlePageLoad);
    return () => {
      window.removeEventListener("load", handlePageLoad);
    };
  }, [searchParams]);
  const renderSections = (sectionName, sectionData) => {
    const itemsPerSection = 6;
    const sections = [];
    for (let i = 0; i < sectionData.length; i += itemsPerSection) {
      sections.push(sectionData.slice(i, i + itemsPerSection));
    }

    return sections.map((chunk, idx) => {
      const gridCols = chunk.length < 3 ? `grid-cols-${chunk.length}` : 'grid-cols-3';
      return (
        <section key={idx} className={`grid ${gridCols} gap-6 mb-6`}>
          <h2 className="col-span-full text-lg font-semibold text-gray-400">{sectionName}</h2>
          {chunk.map((item, idx) => (
            <div key={idx} className="bg-white shadow-md p-4 rounded-lg flex justify-between items-center border border-blue-400 rounded-full">
              <div className="flex-grow text-left">
                <h3 className="text-gray-500 text-lg font-semibold">{item.name} Tickets</h3>
                <p className="text-4xl font-bold text-blue-500">
                  {loading ? "Loading..." : item.value}
                </p>
              </div>
              <div className="text-right">
                <p className="text-4xl font-bold text-blue-500">
                  {loading ? "Loading..." : item.key}
                </p>
              </div>
            </div>
          ))}
        </section>
      );
    });
  };

  return (
    <div>
      <section className="mb-6">
        <section className="mb-6">
          {/* Priority Section */}
          {loading ? (
            <div>Loading...</div>
          ) : (
            ticketSummary
              .filter((section) => section.name === "Priority")
              .map((section, index) => (
                <React.Fragment key={index}>
                  {renderSections("By Priority", section.object)}
                </React.Fragment>
              ))
          )}

          {/* Progress Status Section */}
          {loading ? (
            <div>Loading...</div>
          ) : (
            ticketSummary
              .filter((section) => section.name === "ProgressStatus") // Filter only ProgressStatus data
              .map((section, index) => (
                <React.Fragment key={index}>
                  {renderSections("By Progress", section.object)}
                </React.Fragment>
              ))
          )}
        </section>
      </section>
    </div>
  );
};
export default ClientSummary;
